/* eslint-disable */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router";
import classNames from "classnames";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Favorite from "@material-ui/icons/Favorite";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spinner from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import CornerRibbon from "react-corner-ribbon";

import {
  localApi,
  credentials,
  adminId,
  convertToNextTenth,
} from "utils/headApi";
import { imgApi } from "utils/imgApi";

import productStyle from "assets/jss/material-kit-pro-react/views/productStyle.js";
// import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";

import logo from "assets/img/examples/apple-insha-bangles-icon.png";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

const useStyles = makeStyles(productStyle);
const useStyle = makeStyles(aboutUsStyle);
const useStylPop = makeStyles(popOver);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function InshaSizeMMList() {
  const [prodList, setProdList] = React.useState([]);
  const [loginModal, setLoginModal] = React.useState(false);

  const [stateList, setStateList] = React.useState([]);
  const [categoryList, setCategoryList] = React.useState([]);
  const [parentList, setParentList] = React.useState([]);
  const [companyList, setCompanyList] = React.useState([]);

  const classes = useStyles();
  const classe = useStyle();
  const classPop = useStylPop();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const { search } = useLocation();
  const catdesc = new URLSearchParams(search).get("catdesc");
  const cat1desc = new URLSearchParams(search).get("cat1desc");

  async function getProdSEO() {
    const results = await fetch(localApi + `/admin/groupState`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const res = await results.json();

    // console.log(res.map((f) => f.state));
    setStateList(res.map((f) => f.state));

    axios
      .get(localApi + `/admin/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        setCompanyList(res.data.AdminList.map((f) => f.company));
      });

    axios
      .get(localApi + `/category/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const items = res.data.map((f) => f.title);

        const uniqueItems = items.filter(
          (item, index, self) =>
            index ===
            self.findIndex((i) => i.toLowerCase() === item.toLowerCase()),
        );

        setCategoryList(uniqueItems);
      });

    axios
      .get(localApi + `/parent/allList`, {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      })
      .then((res) => {
        const itemss = res.data.map((f) => f.title);

        const uniqueItemss = itemss.filter(
          (item, index, self) =>
            index ===
            self.findIndex((i) => i.toLowerCase() === item.toLowerCase()),
        );
        setParentList(uniqueItemss);
      });
  }

  useEffect(() => {
    getProdSEO();
  }, []);

  useEffect(() => {
    const catdesc = new URLSearchParams(search).get("catdesc");
    const cat1desc = new URLSearchParams(search).get("cat1desc");

    // fetch(headApi + `/products/byCatMM?catdesc=${catdesc}&cat1desc=${cat1desc}&userid=1&active=1${activeSession ? `&price=${userObj.price}&profit=${userObj.profit}` : `&price=3&profit=10`}`)
    fetch(
      localApi +
        `/product/list/byCatMM?admin_id=${adminId}&active=1&catdesc=${catdesc}&cat1desc=${cat1desc}`,
      {
        method: "GET",

        headers: {
          Authorization: `Basic ${credentials}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);

        setProdList(data);
        // console.log(data);

        // console.log(data.map((m) => m.productimage))
      });

    setTimeout(hideAlertPop, 1000);
    setLoginModal(true);
  }, [search]);

  const hideAlertPop = () => {
    setLoginModal(false);
  };

  return (
    <div className={classes.productPage}>
      <Helmet>
        <html lang="en" />

        <title>
          {catdesc
            ? `${catdesc} Collection | INDIAN BANGLES`
            : "Bangles Collection | INDIAN BANGLES"}
        </title>

        <meta
          name="description"
          content={
            catdesc
              ? `Explore ${catdesc.toLowerCase()} collection from INDIAN BANGLES. Premium imitation jewellery and bangles available for wholesale and export.`
              : "Explore bangles and imitation jewellery collection from INDIAN BANGLES."
          }
        />

        <meta
          name="keywords"
          content={`${
            catdesc || "bangles"
          }, imitation jewellery, wholesale bangles, gold plated bangles`}
        />

        <meta name="robots" content="index, follow" />

        <link
          rel="canonical"
          href={`https://indianbangles.in/size-mm-list?catdesc=${catdesc}&cat1desc=${cat1desc}&Plating=Gold%20Plating`}
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${catdesc} Collection`} />
        <meta
          property="og:description"
          content={`Browse ${catdesc} collection from INDIAN BANGLES.`}
        />
        <meta
          property="og:url"
          content={`https://indianbangles.in/size-mm-list?catdesc=${catdesc}&cat1desc=${cat1desc}&Plating=Gold%20Plating`}
        />
        <meta
          property="og:image"
          content="https://indianbangles.in/imgstore/original_logo/IndianBanglesImgLogo.png"
        />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: catdesc,
            url: `https://indianbangles.in/size-mm-list?catdesc=${catdesc}&cat1desc=${cat1desc}&Plating=Gold%20Plating`,
          })}
        </script>
      </Helmet>
      <InshaHeader
         brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 100,
          color: "dark",
        }}
      />
      <Parallax
        // image={require("assets/img/bg6.jpg").default}
        image={
          catdesc === "BANGLES"
            ? require("assets/img/Bangles.jpg").default
            : catdesc === "EARRINGS"
            ? require("assets/img/Earrings.jpg").default
            : catdesc === "FINGER RINGS"
            ? require("assets/img/Finger-Rings.jpg").default
            : catdesc === "WATCH"
            ? require("assets/img/Watch.jpg").default
            : catdesc === "PUNJABI KADA"
            ? require("assets/img/Punjabi-Kada.jpg").default
            : require("assets/img/Bangles.jpg").default
        }
        filter="dark"
        className={classes.pageHeader}
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8} className={classe.textCenter}>
              <h1 className={classe.title}>{catdesc}</h1>
              <h4 style={{ color: "white" }}>
                {catdesc === "BANGLES" ? (
                  <>
                    Sparkles and glitters all the way. The only method to make
                    your day.
                    <br />
                    Take a little scoop of bangles, we say.
                  </>
                ) : catdesc === "EARRINGS" ? (
                  <>
                    Trends come and go, seasons change yet, certain things stay
                    - your grace,
                    <br />
                    that million dollar smile and timeless jewelry.
                  </>
                ) : catdesc === "FINGER RINGS" ? (
                  <>
                    A promise is forever. A promise to celebrate womanhood goes
                    beyond forever,
                    <br />a challenge we have happily welcomed.
                  </>
                ) : catdesc === "WATCH" ? (
                  <>
                    Take a journey to divineness with each collection, explore
                    watches made with
                    <br />
                    layers of passion and detailing.
                  </>
                ) : catdesc === "PUNJABI KADA" ? (
                  <>
                    Unrevealing divine secrets with each piece of jewelry,
                    <br />
                    the voyage is getting richer and richer.
                  </>
                ) : (
                  ""
                )}
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.section, classes.sectionGray)}>
        <div className={classes.container}>
          <Dialog
            style={{ marginTop: "10%" }}
            classes={{
              root: classPop.modalRoot,
              paper: classPop.modal + " " + classPop.modalLogin,
            }}
            open={loginModal}
            TransitionComponent={Transition}
            keepMounted
            // onClose={() => setLoginModal(false)}
            aria-labelledby="login-modal-slide-title"
            aria-describedby="login-modal-slide-description"
          >
            <DialogTitle
              id="login-modal-slide-title"
              disableTypography
              className={classPop.modalHeader}
            >
              <h5>Loading...</h5>
              <DialogContent
                id="login-modal-slide-description"
                className={classPop.modalBody}
              >
                <GridContainer justify="center">
                  <Spinner
                    onChange={() => hideAlertPop()}
                    style={{ color: "black" }}
                  />
                  {/* <Spinner onChange={() => hideAlertPop()} style={{ color: "#00acc1" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#f44336" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#ff9800" }} />
                    <Spinner onChange={() => hideAlertPop()} style={{ color: "#9c27b0" }} /> */}
                </GridContainer>
                <br />
              </DialogContent>
            </DialogTitle>
          </Dialog>
          <div className={classes.relatedProducts}>
            <h3 className={classNames(classes.title, classes.textCenter)}>
              You may also be interested in:
            </h3>
            <GridContainer>
              {prodList &&
                prodList.map((prod) => {
                  let resultChild = ""; // initialize empty string

                  prod.productchild.forEach((item) => {
                    let line = item.title.trim();

                    if (line.includes("Plating")) {
                      // Remove [ ] brackets
                      line = line.replace(/\[/g, "").replace(/\]/g, "").trim();

                      // Extract only text AFTER "Plating"
                      const afterPlating = line
                        .substring(line.indexOf("Plating") + "Plating".length)
                        .trim();

                      // Clean again
                      const cleanText = afterPlating
                        .replace(/\[/g, "")
                        .replace(/\]/g, "")
                        .trim();

                      // Add to final string
                      resultChild += cleanText + " ";
                    }
                  });
                  return (
                    <GridItem sm={6} md={3} key={prod.id}>
                      <Card product>
                        <CardHeader image>
                          <CornerRibbon
                            position={
                              prod.stockSize.length === 1
                                ? "top-left"
                                : "top-right"
                            } // position="top-right" // OPTIONAL, default as "top-right"
                            fontColor="#f0f0f0" // OPTIONAL, default as "#f0f0f0"
                            backgroundColor="black" // OPTIONAL, default as "#2c7"
                            containerStyle={{}} // OPTIONAL, style of the ribbon
                            style={{ fontSize: "13px", fontWeight: "bold" }} // OPTIONAL, style of ribbon content
                            className="" // OPTIONAL, css class of ribbon
                          >
                            {" "}
                            {prod.stockSize.length === 1
                              ? "In Stock"
                              : "Make To Order"}
                          </CornerRibbon>
                          <a
                            href={`/indian-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                            // &Plating=${prod.plating.description.slice(8)}
                          >
                            {/* {prod.design1.img1active === 1 ? (
                            <img src={imgApi + "" + prod.design1.image1} alt="img1active" />
                          ) : prod.design2.img2active === 1 ? (
                            <img src={imgApi + "" + prod.design2.image2} alt="img2active" />
                          ) : prod.design3.img3active === 1 ? (
                            <img src={imgApi + "" + prod.design3.image3} alt="img3active" />
                          ) : prod.design4.img4active === 1 ? (
                            <img src={imgApi + "" + prod.design4.image4} alt="img4active" />
                          ) : prod.design5.img5active === 1 ? (
                            <img src={imgApi + "" + prod.design5.image5} alt="img5active" />
                          ) : prod.design6.img6active === 1 ? (
                            <img src={imgApi + "" + prod.design6.image6} alt="img6active" />
                          ) : (
                            ""
                          )} */}
                            <img
                              src={prod.productimage[0].cpanelPath}
                              alt="..."
                            />
                            <p
                              style={{
                                position: "absolute",
                                top: "65%",
                                left: "50%",
                                width: "65px",
                                height: "65px",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <img src={logo} alt="logo1" />
                              {/* {imgApi + "" + prod.design1.image1 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo1" />
                            ) : imgApi + "" + prod.design2.image2 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo2" />
                            ) : imgApi + "" + prod.design3.image3 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo3" />
                            ) : imgApi + "" + prod.design4.image4 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo4" />
                            ) : imgApi + "" + prod.design5.image5 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo5" />
                            ) : imgApi + "" + prod.design6.image6 !==
                              imgApi + "" + "/crop_img/null" ? (
                              <img src={logo} alt="logo6" />
                            ) : (
                              ""
                            )} */}
                            </p>
                          </a>
                        </CardHeader>
                        <h6
                          className={classNames(
                            classes.cardCategory,
                            classes.textRose,
                          )}
                        >
                          {prod.category.title + " " + prod.parent.title} <br />{" "}
                          {resultChild.trim()}-{prod.id}
                        </h6>
                      </Card>
                      <Card>
                        <CardBody>
                          <div className={classes.cardDescription}>
                            {(prod.readyGram * prod.sets.pcs).toFixed(4)} Avg
                            Gram Of {prod.sets.setDesc} {"and "}
                            {prod.box.boxDesc}
                            {","} {"(" + prod.packingMaterial.type + ")"}
                            {","} {prod.box.brandName}
                            {","} {prod.ctnDescription}
                            {"."}
                          </div>
                        </CardBody>
                        <CardFooter className={classes.justifyContentBetween}>
                          <div className={classes.price}>
                            {prod.gstCash === true ? (
                              <>
                                <h5>
                                  <span style={{ color: "red" }}>
                                    Price ₹{" "}
                                    {convertToNextTenth(
                                      prod.taxInclude / prod.box.box,
                                    ) + " Inc."}
                                  </span>
                                </h5>
                              </>
                            ) : (
                              <>
                                <h5>
                                  <span style={{ color: "black" }}>
                                    Price ₹{" "}
                                    {convertToNextTenth(
                                      prod.cashPrice / prod.box.box,
                                    )}
                                  </span>
                                </h5>
                              </>
                            )}

                            {/* {!activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              prod.taxCalculation.cash_gst === 1 ? (
                                <>
                                  <h5>
                                    <span style={{ color: "red" }}>
                                      Price ₹{" "}
                                      {(
                                        prod.taxCalculation.taxincl /
                                        prod.box.box
                                      ).toFixed(2)}
                                      /-
                                    </span>
                                  </h5>{" "}
                                  <h6>
                                    <a href="/indian-login">Login</a> to see
                                    prices and exciting offers.
                                  </h6>{" "}
                                </>
                              ) : (
                                <h5>
                                  Price{" "}
                                  <span>
                                    ₹{" "}
                                    {(
                                      prod.taxCalculation.cash / prod.box.box
                                    ).toFixed(2)}
                                    /-*
                                  </span>
                                </h5>
                              )
                            ) : prod.taxCalculation.cash_gst === 1 ? (
                              <>
                                <h5>
                                  <span style={{ color: "#9c27b0" }}>
                                    Price ₹{" "}
                                    {(
                                      prod.taxCalculation.taxincl / prod.box.box
                                    ).toFixed(2)}
                                    /-
                                  </span>
                                </h5>{" "}
                                <h6>
                                  <a href="/indian-login">Login</a> to see
                                  prices and exciting offers.
                                </h6>
                              </>
                            ) : (
                              <h5>
                                Price{" "}
                                <span>
                                  ₹{" "}
                                  {(
                                    prod.taxCalculation.cash / prod.box.box
                                  ).toFixed(2)}
                                  /-*
                                </span>
                              </h5>
                            )
                          ) : (
                            ""
                          )}



                          {activeSession ? (
                            prod.taxCalculation.profitactive === 1 ? (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "red",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            ) : (
                              <h6>
                                <span
                                  style={{
                                    textDecoration: "line-through",
                                    color: "#9c27b0",
                                  }}
                                >
                                  Price ₹
                                  {(
                                    prod.taxCalculation.taxincl / prod.box.box
                                  ).toFixed(2)}
                                  /
                                </span>{" "}
                                ₹{" "}
                                {(
                                  prod.taxCalculation.cash / prod.box.box
                                ).toFixed(2)}
                                /-*
                              </h6>
                            )
                          ) : (
                            ""
                          )} */}
                          </div>
                          <div className={classes.stats}>
                            <Tooltip
                              id="tooltip-top"
                              title="Save to Wishlist"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <Button justIcon color="rose" simple>
                                <Favorite />
                              </Button>
                            </Tooltip>
                          </div>
                        </CardFooter>
                        <div
                          style={{ textAlign: "center", marginBottom: "7px" }}
                        >
                          <Button
                            color="rose"
                            href={`/indian-product?id=${prod.id}&catdesc=${prod.category.title}&cat1desc=${prod.parent.title}`}
                          >
                            Buy Now
                          </Button>
                        </div>
                        {/* <CardFooter className={classes.justifyContentBetween}>
                        <div style={{textAlign : "center", marginBottom: "7px"}}>
                          <Button
                            color="rose"
                            href={`/indian-product?id=${prod.id}&catdesc=${prod.productCategory.title
                              }&cat1desc=${prod.productParent.title
                              }`}
                          >
                            Buy Now
                          </Button>
                        </div>
                        <div>
                          <Button
                            color="success"
                            round
                            justIcon
                            href={`https://api.whatsapp.com/send/?phone=${prod.user.whatsapp
                              }&text=https://indianbangles.in/indian-product?id=${prod.id
                              }%20${prod.banglessizemm.description
                              }%20${prod.plating.description.slice(
                                8
                              )}&app_absent=0`}
                          >
                            <i
                              className="fab fa-whatsapp"
                              style={{ fontSize: "30px" }}
                            />
                          </Button>
                        </div>
                      </CardFooter> */}
                      </Card>
                    </GridItem>
                  );
                })}
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
